import { render, staticRenderFns } from "./ProximosPartidosTitulo.vue?vue&type=template&id=790fda06&"
import script from "./ProximosPartidosTitulo.vue?vue&type=script&lang=js&"
export * from "./ProximosPartidosTitulo.vue?vue&type=script&lang=js&"
import style0 from "./ProximosPartidosTitulo.vue?vue&type=style&index=0&id=790fda06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports